import React from 'react';

export const Ads = () => {
  return (
    <aside className="ads-panel">
      <h3 className="ads-panel__title">Advertisement</h3>
      <div className="ads-card">
        <div className="ads-card__media">
          <span>Ad Space</span>
        </div>
        <p className="ads-card__headline">Premium Campaign Tools</p>
        <p className="ads-card__copy">
          Boost your campaign reach with our premium tools and analytics.
        </p>
        <button className="ads-card__button">Learn More</button>
      </div>
    </aside>
  );
};

export default Ads;
